<template>
  <svg
    :width="width"
    :height="height"
    :viewBox="`0 0 ${width} ${height}`"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.180664"
      y="0.092041"
      :width="width"
      :height="height"
      rx="1.4335"
      fill="#E11D23"
    />
  </svg>
</template>
<script setup lang="ts">
interface Props {
  width?: number;
  height?: number;
}

const props = withDefaults(defineProps<Props>(), {
  width: 8,
  height: 11,
});
</script>
<script lang="ts">
export default {};
</script>
